<template>
    <div class="container pt-4 pb-5" id="itb-privacy-policy">
        <h1>
            Soubory Cookies
        </h1>
        <p style="opacity: 0.5">Poslední aktualizace: 31. března 2022</p>
        <p>
            Tyto zásady používání souborů cookie vysvětlují, co jsou to soubory
            cookie a jak je používáme. Měli byste si tyto zásady přečíst, abyste
            pochopili, jaký typ souborů cookie používáme nebo jaké informace
            pomocí souborů cookie shromažďujeme a jak jsou tyto informace
            využívány.
        </p>
        <p>
            Soubory cookie obvykle neobsahují žádné informace, které by osobně
            identifikovaly uživatele, ale osobní informace, které o Vás
            ukládáme, mohou být spojeny s informacemi uloženými v souborech
            cookie a získanými z nich. Další informace o tom, jak používáme,
            uchováváme a zabezpečujeme vaše osobní údaje, naleznete v našich
            Zásadách ochrany osobních údajů.
        </p>
        <p>
            V Souborech cookie, které používáme, neukládáme citlivé osobní
            údaje, jako jsou poštovní adresy, hesla k účtům atd.
        </p>

        <h2>Výklad a definice</h2>

        <h3>Výklad</h3>
        <p>
            Slova, jejichž počáteční písmeno je psáno velkým písmenem, mají
            význam definovaný za následujících podmínek. Následující definice
            mají stejný význam bez ohledu na to, zda jsou uvedeny v jednotném
            nebo množném čísle.
        </p>

        <h3>Definice</h3>
        <p>Pro účely těchto Zásad používání souborů cookie:</p>

        <ul>
            <li>
                <strong>Společnost</strong> (v těchto Zásadách používání souborů
                cookie označovaná jako "Společnost", "My", "Nás" nebo "Naše") se
                vztahuje na společnost 4soft s.r.o., Krkonošská 625 468 41
                Tanvald.
            </li>
            <li>
                <strong>Soubory cookie</strong> se rozumí malé soubory, které
                jsou umístěny do Vašeho počítače, mobilního zařízení nebo jiného
                zařízení webovou stránkou a které obsahují mimo jiné údaje o
                historii Vašeho prohlížení na dané webové stránce.
            </li>
            <li>
                <strong>Webové stránky</strong> se vztahují k adrese
                <a href="https://4soft.cz/" target="_blank">4soft.cz</a>.
            </li>
            <li>
                <strong>Vy</strong> znamená fyzickou osobu, která přistupuje na
                webové stránky nebo je používá, případně společnost nebo
                jakoukoli právnickou osobu, jejímž jménem taková osoba
                přistupuje na webové stránky nebo je používá.
            </li>
        </ul>

        <h2>Používání souborů cookie</h2>

        <h3>Typ souborů cookie, které používáme</h3>
        <p>
            Soubory cookie mohou být "trvalé" nebo "relační". Trvalé soubory
            cookie zůstávají ve vašem osobním počítači nebo mobilním zařízení,
            když přejdete do režimu offline, zatímco relační soubory cookie se
            vymažou, jakmile zavřete webový prohlížeč.
        </p>
        <p>
            Pro účely uvedené níže používáme jak relační, tak trvalé soubory
            cookie:
        </p>

        <ul>
            <li>
                <strong>Nezbytné / nezbytné soubory cookie</strong> <br />Typ:
                Soubory cookie relace<br />Spravuje: my<br />Účel: Tyto soubory
                cookie jsou nezbytné k tomu, aby vám mohly být poskytovány
                služby dostupné prostřednictvím webových stránek a abyste mohli
                využívat některé jejich funkce. Pomáhají ověřovat uživatele a
                zabraňují podvodnému používání uživatelských účtů. Bez těchto
                souborů cookie nelze poskytovat služby, o které jste požádali, a
                my tyto soubory cookie používáme pouze k tomu, abychom vám tyto
                služby poskytli.
            </li>
            <li>
                <strong>Funkční soubory cookie</strong><br />Typ: Trvalé soubory
                cookie<br />Spravuje: my<br />Účel: Tyto soubory cookie nám
                umožňují zapamatovat si volby, které jste učinili při používání
                webových stránek, například zapamatovat si vaše přihlašovací
                údaje nebo předvolbu jazyka. Účelem těchto souborů cookie je
                poskytnout Vám osobnější zážitek a zabránit tomu, abyste museli
                znovu zadávat své preference při každém použití Webových
                stránek.
            </li>
        </ul>

        <h3>Vaše volby týkající se souborů cookie</h3>
        <p>
            Pokud dáváte přednost tomu, abyste se vyhnuli používání souborů
            cookie na Webových stránkách, musíte nejprve zakázat používání
            souborů cookie ve svém prohlížeči a poté vymazat soubory cookie
            uložené ve vašem prohlížeči spojené s těmito webovými stránkami.
            Tuto možnost zabránění používání souborů Cookies můžete využít
            kdykoli.
        </p>
        <p>
            Pokud naše Cookies neakceptujete, může dojít k určitým
            nepříjemnostem při používání webových stránek a některé funkce
            nemusí fungovat správně.
        </p>
        <p>
            Pokud chcete odstranit soubory Cookies nebo dát pokyn svému webovému
            prohlížeči, aby soubory Cookies odstranil nebo odmítl, navštivte
            prosím stránky nápovědy svého webového prohlížeče.
        </p>

        <ul>
            <li>
                V případě webového prohlížeče Chrome navštivte tuto stránku
                společnosti Google:
                <a
                    href="https://support.google.com/accounts/answer/32050"
                    target="_blank"
                    >https://support.google.com/accounts/answer/32050</a
                >.
            </li>
            <li>
                Pro webový prohlížeč Internet Explorer navštivte tuto stránku
                společnosti Microsoft:
                <a href="http://support.microsoft.com/kb/278835" target="_blank"
                    >http://support.microsoft.com/kb/278835</a
                >.
            </li>
            <li>
                Webový prohlížeč Firefox naleznete na této stránce Mozilly:
                <a
                    href="https://support.mozilla.org/en-US/kb/delete-cookies-remove-info-websites-stored"
                    target="_blank"
                    >https://support.mozilla.org/en-US/kb/delete-cookies-remove-info-websites-stored</a
                >.
            </li>
            <li>
                Webový prohlížeč Safari naleznete na této stránce společnosti
                Apple:
                <a
                    href="https://support.apple.com/guide/safari/manage-cookies-and-website-data-sfri11471/mac"
                    target="_blank"
                    >https://support.apple.com/guide/safari/manage-cookies-and-website-data-sfri11471/mac</a
                >.
            </li>
        </ul>

        <p>
            Pro jakýkoli jiný webový prohlížeč navštivte oficiální webové
            stránky svého prohlížeče.
        </p>

        <h3>Další informace o souborech cookie</h3>
        <p>
            O souborech cookie se můžete dozvědět více:
            <a
                href="https://www.privacypolicies.com/blog/cookies/"
                target="_blank"
                >What Are Cookies?</a
            >.
        </p>

        <h3>Kontaktujte nás:</h3>
        <p>
            Máte-li jakékoli dotazy týkající se těchto Zásad používání souborů
            cookie, můžete nás kontaktovat e-mailem:
            <a href="mailto:info@4soft.cz">info@4soft.cz</a>
        </p>
    </div>
</template>
<script>
import { mapActions, mapGetters } from "vuex";
export default {
    data() {
        return {};
    },
    mounted() {
        axios
            .get("/getCookiesPolicyPage")
            .then(response => {
                // this.heroCards = response.data.heroCards;
                this.pageParams = response.data.params;
                this.setPageParams(this.pageParams);
            })
            .catch(error => {
                console.log(error);
            });
    },
    methods: {
        ...mapActions(["setPageParams", "setFormParams"])
    }
};
</script>
